import { render, staticRenderFns } from "./AS_Project.vue?vue&type=template&id=59900dc1&scoped=true&"
import script from "./AS_Project.vue?vue&type=script&lang=js&"
export * from "./AS_Project.vue?vue&type=script&lang=js&"
import style0 from "./AS_Project.vue?vue&type=style&index=0&id=59900dc1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59900dc1",
  null
  
)

export default component.exports